import React, { ReactText, useState } from "react"
import ReactModal from "react-modal"
// import { useMediaQuery } from "react-responsive"
import tw, { styled, css } from "twin.macro"

import SlideSection from "../components/slideSection"
import NextPageButton from "../components/nextPageButton"
import { modalStyles } from "../utils/modalStyles"
import LearnDetail from "../components/learnDetail"
import CloseIcon from "../svgs/closeIcon"
import IconTime1 from "../icons/iconTime1"
import IconTime2 from "../icons/iconTime2"
import IconTime3 from "../icons/iconTime3"
import Container from "../components/container"
import { SlideProps } from "."
import NextPageContainer from "../components/nextPageContainer"

const Features = styled.div`
  ${tw`flex flex-col md:flex-row justify-center items-center`}
`

const Feature = styled.div`
  max-width: 20rem;
  padding: 0 2.1875rem;
  @media (max-width: 768px) {
    margin-bottom: 0.5rem;
  }
  ${tw`flex flex-col items-center md:w-1/3 mb-16 md:mb-0`}
`

const FeatureName = styled.h3`
  ${tw` text-lg text-sm font-bold uppercase mt-4 md:mt-6 mb-4 text-center tracking-wider whitespace-pre-line`}
`

const FeatureDescription = styled.p`
  font-family: Interstate; font-size: 30px; line-height: 30px; font-weight: 700; letter-spacing: 0.5px;
  ${tw`text-center mb-6 whitespace-pre-line`}
`
const LearnMoreLink = styled.a`
padding: 12.5px; background-color: #FFFFFF; color: #0063A6;
font-family: Interstate;
${tw`rounded text-lg tracking-wide uppercase hidden md:inline hover:bg-white hover:text-black focus:outline-none text-center block`}
`

interface FeatureData {
  icon: React.FC
  title: ReactText
  description: ReactText
  details?: FeatureDetails[]
}

interface FeatureDetails {
  title?: string
  text: string[]
}

const features: FeatureData[] = [
  {
    icon: IconTime1,
    title: "",
    description:
      "1 Month",
  },
  {
    icon: IconTime2,
    title: "",
    description: "3 Months",
  },
  {
    icon: IconTime3,
    title: "",
    description:
      "4 Months",
  },
]

const FeaturesSlide: React.SFC<SlideProps> = ({
  slideVisible,
  nextButtonClicked,
}) => {
  const [featureIndex, setFeatureIndex] = useState<number>(-1)

  // const isSmall = useMediaQuery({ query: "(max-width: 767px)" })

  return (
    <SlideSection autoHeightResponsive>
      <div css={[tw`flex flex-col justify-center items-center`]}>
        <Container>
          {/* Fade + translate the icon in */}
          <div
            css={[
              tw`transition duration-1000 ease-out text-center`,
              !slideVisible && tw`opacity-0 transform -translate-y-8`,
            ]}
          >
            <div css={[tw`flex flex-col justify-center items-center text-center mb-16 w-1/3 ml-auto mr-auto mt-20`]}>
              <tspan css={[
                css`font-family:Interstate; font-weight: 700; font-size:60px; line-height: 55.8px; text-align: center; letter-spacing:0.117;
                @media (max-width: 768px) {
                  font-size: 45px; 
                  line-height: 48px;
                  width: 76vw;
                }
                `
              ]}>
                {"How long will it take?"}
              </tspan>
            </div>
          </div>
          {/* Fade the text in */}
          <Features>
            {features.map((feature, index) => {
              const delay = `transition-delay: ${
                slideVisible ? 250 + index * 175 : 0
              }ms`
              return (
                <Feature key={index}>
                  {/* Fade + translate the icon in */}
                  <div
                    css={[
                      css`
                      @media (max-width: 768px) {
                        width: 45vw;
                      }
                        ${delay}
                      `,
                      tw`transition duration-1000 ease-out`,
                      !slideVisible && tw`opacity-0 transform -translate-y-8`,
                    ]}
                  >
                    <feature.icon />
                  </div>
                  {/* Fade the text in */}
                  <div
                    css={[
                      css`
                        ${delay}
                      `,
                      tw`transition duration-1000 ease-out`,
                      !slideVisible && tw`opacity-0`,
                    ]}
                  >
                    <FeatureName>{feature.title}</FeatureName>
                    <FeatureDescription>
                      {feature.description}
                    </FeatureDescription>
                  </div>
                </Feature>
              )
            })}
          </Features>
        </Container>

        <NextPageContainer>
          <NextPageButton
            onClick={nextButtonClicked}
            label=""
          />
        </NextPageContainer>
      </div>
    </SlideSection>
  )
}

export default FeaturesSlide
